import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayAccountPrivateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.49 13.64C14.18 13.64 17.19 10.64 17.19 6.94C17.19 3.24 14.18 0.25 10.49 0.25C6.79998 0.25 3.78998 3.25 3.78998 6.95C3.78998 10.65 6.78998 13.65 10.49 13.65V13.64ZM10.49 1.75C13.35 1.75 15.69 4.08 15.69 6.95C15.69 9.82 13.36 12.15 10.49 12.15C7.61998 12.15 5.28998 9.82 5.28998 6.95C5.28998 4.08 7.61998 1.75 10.49 1.75Z"
        fill={color}
      />
      <path
        d="M19 20.18C19.6517 20.18 20.18 19.6517 20.18 19C20.18 18.3483 19.6517 17.82 19 17.82C18.3483 17.82 17.82 18.3483 17.82 19C17.82 19.6517 18.3483 20.18 19 20.18Z"
        fill={color}
      />
      <path
        d="M22.5 15.38H22.12V15C22.12 13.28 20.72 11.88 19 11.88C17.28 11.88 15.88 13.28 15.88 15V15.38H15.5C15.19 15.38 14.91 15.51 14.7 15.72C13.41 15.34 11.99 15.12 10.5 15.12C6.71003 15.12 3.36003 16.44 1.54003 18.65C0.770027 19.59 0.610027 20.85 1.13003 21.94C1.66003 23.06 2.77003 23.75 4.02003 23.75H16.98C17.95 23.75 18.83 23.33 19.42 22.63H22.5C23.12 22.63 23.62 22.13 23.62 21.51V16.51C23.62 15.89 23.12 15.39 22.5 15.39V15.38ZM4.02003 22.25C3.34003 22.25 2.77003 21.89 2.49003 21.3C2.22003 20.73 2.30003 20.09 2.70003 19.6C4.24003 17.73 7.15003 16.62 10.5 16.62C11.89 16.62 13.2 16.82 14.38 17.18V21.5C14.38 21.79 14.5 22.05 14.68 22.25H4.02003ZM17.12 15C17.12 13.97 17.96 13.12 19 13.12C20.04 13.12 20.88 13.96 20.88 15V15.38H17.13V15H17.12ZM22.38 21.38H15.63V16.63H22.38V21.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayAccountPrivateIcon.displayName = 'PayAccountPrivateIcon';
